import { useCallback, useContext, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

// KN imports
import { TripDetailsContext } from 'context/trips/TripDetailsContext'
import KNButtonGroup from 'components/KNButtonGroup/KNButtonGroup'

export interface ViewSwitcherProps {
  stopsViewAvailable?: boolean
}

const ViewSwitcher = ({ stopsViewAvailable }: ViewSwitcherProps): ReactElement => {
  const { t } = useTranslation()
  const [tripDetailsState, tripDetailsDispatch] = useContext(TripDetailsContext)
  const availableViews = stopsViewAvailable ? ['shipments', 'stops', 'sequence_map'] : ['shipments', 'locations_map']

  const handleViewChange = useCallback((value: string) => {
    tripDetailsDispatch({ type: 'setDetailsView', payload: value })
  }, [])

  return (
    <KNButtonGroup
      size="small"
      value={tripDetailsState.detailsView}
      onChange={handleViewChange}
      options={availableViews.map((view) => ({
        value: view,
        label: t(`screens.cs.trip_details.views.${view}`),
      }))}
    />
  )
}

export default ViewSwitcher
